import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, SectionTabs, Stack } from '@shared/ui';

import type { UILibrarySectionConfig, UILibrarySectionId } from '../ui-library-sections';

interface UILibraryLayoutProps {
  sections: UILibrarySectionConfig[];
  sectionContent: Record<UILibrarySectionId, React.ReactNode>;
  defaultSectionId?: UILibrarySectionId;
}

export function UILibraryLayout({
  sections,
  sectionContent,
  defaultSectionId,
}: UILibraryLayoutProps) {
  const { t } = useTranslation();
  const translate = (key: string) => t(key as never) as string;
  const navItems = sections.map((section) => ({
    id: section.id,
    label: translate(section.labelKey),
  }));
  const [activeSectionId, setActiveSectionId] = useState<UILibrarySectionId>(
    defaultSectionId ?? sections.at(0)?.id ?? 'tokens'
  );
  const activeSection = sectionContent[activeSectionId];

  return (
    <div className="min-h-screen bg-background">
      <div className="relative min-h-screen">
        <div className="flex-1">
          <Container size="full" className="p-6">
            <Stack gap="lg">
              <div>
                <SectionTabs
                  items={navItems}
                  activeId={activeSectionId}
                  onSelect={(id) => {
                    setActiveSectionId(id as UILibrarySectionId);
                  }}
                />
              </div>

              <main className="min-w-0">{activeSection}</main>
            </Stack>
          </Container>
        </div>
      </div>
    </div>
  );
}
